import store from '@/store/index';

export default [
  {
    path: '*',
    redirect: () => {
      return ('/platform/parking-payment')
    }
  },
  {
    path: '/login',
    meta: {
      name: 'Login',
      requiresAuth: false
    },
    component: () =>
      import (`@/pages/Login.vue`),
    beforeEnter: (to, from, next) => {
      if (store.getters['app/username']) {
        next('/platform/parking-payment')
      }
      next()
    },
  },
  {
    path: '/privacy-policy',
    meta: {
      name: 'PrivacyPolicy',
      requiresAuth: false
    },
    component: () =>
      import (`@/pages/PrivacyPolicy.vue`),
  },
  {
    path: '/terms-and-conditions',
    meta: {
      name: 'TNC',
      requiresAuth: false
    },
    component: () =>
      import (`@/pages/TNC.vue`),
  },
  {
    path: '/platform',
    meta: {
      name: 'Platform',
      requiresAuth: true
    },
    component: () =>
      import (`@/pages/Platform.vue`),
    beforeEnter: (to, from, next) => {
      store.commit("app/set_loader", true)
      // if (store.state.app.places.length === 0) {
      //   store.dispatch("app/getPlacesInfo")
      // }

      let historyWatcher = setInterval(() => {
        if (store.state.app.places.length) {
          store.dispatch('dashboard/getDashboardConfig');
          store.dispatch('app/getCarTypes')
          store.dispatch('app/getGuestTypes');
          if (store.state.guests.guest_list.length === 0) {
            store.dispatch("guests/getGuests")
          }

          if (store.getters['app/hasZones']) {
            store.dispatch("app/getZones")
          }

          clearInterval(historyWatcher)
          setTimeout(() => {
            store.commit("app/set_loader", false)
          }, 700)
          next()
        }
      }, 500);
    },
    children: [
      {
        meta: {
          name: 'ParkingPayment',
          requiresAuth: true
        },
        path: '/platform/parking-payment',
        component: () =>
          import (`@/views/ParkingPayment.vue`),
        beforeEnter(to, from, next) {
          store.commit("app/set_tab", "parking_payment")
          next()
        }
      },
    ]
  },
];
